// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/public/common.css
// module id = 23
// module chunks = 9